var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('address-auto-complete'),_c('quay-filters'),_c('h4',{staticClass:"pl-4"},[_vm._v("Haltes in de buurt van "+_vm._s(_vm.currentLocationName))]),_c('v-divider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }